/* eslint-disable max-lines-per-function */
import React, { useEffect, useRef, useState } from 'react';
import { Formik } from 'formik';
import * as yup from 'yup';
import { Messages } from 'primereact/messages';
import { Card } from 'primereact/card';
import './styleEnvioDeAceite.css';
import FundoAmarelo from '../../../assets/fundo_amarelo.png';
import { validaTelefone } from '../../assinatura/validaTelefone';
import { showMessageAlert, showMessageError, showMessageSuccess } from '../../others/toastr';
import EnvioDeAceiteForm from './EnvioDeAceiteForm';
import { atuatualizarLogUpSell, enviarAceiteUpSell } from '../../../services/upSell';
import getTipoColaborador from '../../../helpers/getTipoColaborador';
import { decriptObjectOnLocalStorage, decriptoLocalStorage } from '../../../modulos/cripotografia/criptoStorage';
import { converterValorMonetarioParaNumero } from '../funcoesUpSell';

export default function EnvioDeAceite({ inscricao, contatosAssociado, fecharModal, valorTotalMensal }) {
    const [loading, setLoading] = useState(false);
    const [celularInvalido, setCelularInvalido] = useState(false);
    const [dadosVendedor, setDadosVendedor] = useState({});

    const messages = useRef(null);

    const initialValues = {
        FormaEnvio: '',
        TipoAceite: '8',
        EmailEnvio: contatosAssociado.AssEmail || '',
        TelefoneEnvio: contatosAssociado.Celular || ''
    };

    const enumTipoEnvioAceite = {
        1: 'SMS',
        2: 'EMAIL',
        3: 'WHATSAPP'
    };

    useEffect(() => {
        const tipoColaborador = getTipoColaborador(decriptObjectOnLocalStorage('PERM'));
        const codigoVendedor = decriptoLocalStorage('codigo_vendedor')?.decriptoValue;

        setDadosVendedor({
            tipoColaborador,
            codigoVendedor
        });
    }, []);

    const validations =
        yup.object().shape({
            EmailEnvio: yup
                .string()
                .email('Email não é válido')
                .when('FormaEnvio', {
                    is: 2,
                    then: yup.string().email().required().test(
                        '',
                        '@grupozelo.com não é um domínio permitido!',
                        value => !value?.toLowerCase().includes('@grupozelo')
                    ),
                    otherwise: yup.string().email()
                }),
            TelefoneEnvio: yup
                .string()
                .when('FormaEnvio', {
                    is: value => value === 1 || value === 3,
                    then: yup.string().required().test(
                        '',
                        'celular inválido',
                        value => {
                            const celularFormatado = value?.replace(/ |-|\(|\)/gi, '');

                            if (!Number(celularFormatado) || `${Number(celularFormatado)}`.length !== 11) {
                                setCelularInvalido(true);

                                return false;
                            }

                            if (!validaTelefone(celularFormatado)) {
                                setCelularInvalido(true);

                                return false;
                            }

                            setCelularInvalido(false);

                            return true;
                        }
                    )
                })

        });

    const infoVendedor = {
        inscricao,
        tipo: dadosVendedor.tipoColaborador,
        codigo: dadosVendedor.codigoVendedor
    };

    const salvarValorTotalPlanoMigracao = async () => {
        const body = {
            novoValorTotal: converterValorMonetarioParaNumero(valorTotalMensal)
        };

        await atuatualizarLogUpSell(infoVendedor, body);
    };

    const handleSubmit = async values => {
        try {
            setLoading(true);
            values.Inscricao = inscricao;

            if (!values.FormaEnvio) {
                const msgErro = 'Por favor selecione uma forma de envio e tente novamente.';

                showMessageAlert('warning', msgErro, 'toast-top-center');
            } else {
                const body = {
                    formaEnvio: enumTipoEnvioAceite[values.FormaEnvio],
                    emailEnvio: values?.EmailEnvio,
                    telefoneEnvio: values?.TelefoneEnvio.replace(/[()\s-]/g, '')
                };

                const response = await enviarAceiteUpSell(infoVendedor, body);

                if (response.status === 409) {
                    showMessageError('Error', response.data.mensage, 'toast-top-center');
                    fecharModal();
                } else if (response.status !== 200) {
                    showMessageError('Error', 'Falha ao enviar o Aceite!', 'toast-top-center');
                    fecharModal();
                } else {
                    await salvarValorTotalPlanoMigracao();
                    showMessageSuccess('Sucesso', 'Aceite enviado com sucesso!', 'toast-top-center');
                    fecharModal();
                }
            }
        } catch (error) {
            setLoading(false);
            fecharModal();
        }
    };

    const header = <img alt="Card" src={FundoAmarelo} />;

    return (
        <div className="modal" >
            <div className="content">
                <Card header={header} title="Envio de Aceite UpSell">
                    <div style={{ display: 'inline-block' }}>
                        <Messages className='messageContent' ref={messages} />
                    </div>
                    {loading ? (
                        <i className="pi pi-spin pi-spinner is-loading" />
                    ) : (
                        <Formik
                            initialTouched={{
                                TelefoneEnvio: true,
                                EmailEnvio: true
                            }}
                            onSubmit={handleSubmit}
                            initialValues={initialValues}
                            validationSchema={validations}
                        >
                            <EnvioDeAceiteForm celularInvalido={celularInvalido} fecharModal={fecharModal} />
                        </Formik>
                    )}
                </Card>
            </div>
        </div >
    );
}